export function showPriceConfirmModal(
  confirmCallback: () => void
) {
  const confirmEl: HTMLTambrPriceConfirmDialogElement = document.createElement('tambr-price-confirm-dialog');
  confirmEl.addEventListener( 'tambrPriceConfirmDialogResponse', async (res: any) => {
    confirmEl.remove();
    if ( res.detail === 'confirm' ) { 
      confirmCallback();
    } else if ( res.detail === 'cancel' ) {
      confirmEl.remove();
    }
  } );
  document.body.appendChild( confirmEl );
}